import { AfterViewInit, Component, HostListener, NgZone, Renderer2, ViewEncapsulation } from '@angular/core';
import { AlertController, MenuController, ModalController, Platform } from '@ionic/angular';
import { Router, NavigationEnd, ActivatedRouteSnapshot } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Capacitor } from '@capacitor/core';
import { CrewSelfService } from 'src/app/shared/services/crew-self.service';
import { UserApiService } from '../app/shared/services/user-api.service';
import { Subscription } from 'rxjs';
import { StorageService } from './shared/services/storage.service';
import { AuthApiService } from './shared/services/auth-api.service';
import { AuthService } from './shared/services/auth.service';
import { Network } from '@capacitor/network';
import { ViewportScroller, Location } from '@angular/common';
import { App, App as CapacitorApp } from '@capacitor/app';
import { Browser } from '@capacitor/browser';
import { HttpClient } from '@angular/common/http';
import posthog from 'posthog-js';
import { environment } from 'src/environments/environment';
import { Keyboard } from '@capacitor/keyboard';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements AfterViewInit{

  public sidebar = true;
  public isDesktop = false;
  public subscription: Subscription;
  menuType: string = 'overlay';
  public isNative: boolean = false;
  public activeMenuItem: string = 'home';
  public pageTitle: string = 'Home';
  public bottomMenuOptions: any = [];
  public isSkelton: boolean = true;
  public device: string = '';
  public nativeClass: string = 'web';
  public isCollapsed: boolean = false;
  public isOffline: boolean = false;
  public loginUserDetail = {
    login_user_name: 'John Doe',
    designation: 'Captain',
    profileImage: 'assets/img/user-placeholder.svg',
    role: ''
  };
  private isNetworkListenerAttached = false;
  constructor(
    private readonly ngZone: NgZone,
    private readonly _storageService: StorageService,
    private readonly platform: Platform,
    private readonly menu: MenuController,
    private readonly modalController: ModalController,
    private readonly router: Router,
    private readonly titleService: Title,
    private readonly crewSelfService: CrewSelfService,
    private readonly authApiService: AuthApiService,
    private readonly authService: AuthService,
    private readonly userApiService: UserApiService,
    private readonly renderer: Renderer2,
    private readonly viewportScroller: ViewportScroller,
    private readonly location: Location,
    private readonly alertController: AlertController,
    private readonly http: HttpClient,
  ) {

    this.getRouter();
    this.device = this.getDevive();
    console.log('AppComponent: Platform detected:', this.device);

    this.crewSelfService.isDesktopSet();
    this.crewSelfService.setCurrentPlatform();
    this.subscription = this.crewSelfService.isDesktopGet().subscribe((event) => {
      this.isDesktop = event;
      if (this.isDesktop) {
        this.renderer.addClass(document.documentElement, 'plt-desktop');
      }
    });

    if (Capacitor.getPlatform() === 'android') {
      console.log('AppComponent: Initializing Android platform specific logic.');
      this.initializeApp();
    }
  }

  isAccessGranted(): boolean {
    const url = this.router.url;

    if (url === '/battery-optimization-required' || url === '/access-denied' || url === '/page/privacy-policy' || url.includes('page/acknowledge') || url === '/access-denied') {
      return true;
    }

    const token = this._storageService.getDataFromStorage("access_token");
    const hasToken = !!token;
    return hasToken;
  }

  getRouter() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        console.log('AppComponent: NavigationEnd event:', event.url);

        this.viewportScroller.scrollToPosition([0, 0]);
        this.parseRoute(this.router.routerState.snapshot.root);

        let splitUrl = event.url.split('/');
        let url = splitUrl[1] ? splitUrl[1] : this.activeMenuItem;
        this.activeMenuItem = url;
        console.log('AppComponent: Active menu item set to:', url);

        this.loadMenuOption(url);
        this.closeMenu();

        if (this.authService.isNative) {
          this.isNative = true;
          this.nativeClass = 'native';
          console.log('AppComponent: Native platform detected.');
        }

        if (url === 'home' || url === 'notifications') {
          console.log('AppComponent: Fetching crew notifications for:', url);
          this.getCrewBasicNotifications();
        }
      }
    });
  }


  initializeApp() {
    this.platform.ready().then(() => {
      console.log('AppComponent: Platform ready.');

      CapacitorApp.addListener('backButton', async () => {
        console.log('AppComponent: Android back button pressed.');

        const modal = await this.modalController.getTop();
        if (modal) {
          console.log('AppComponent: Dismissing top modal.');
          modal.dismiss();
          return;
        }

        const currentUrl = this.router.url;
        const rootPages = ['/home'];
        console.log('AppComponent: Current route on back press:', currentUrl);

        if (!rootPages.includes(currentUrl)) {
          this.location.back();
          console.log('AppComponent: Navigating back.');
        } else {
          console.log('AppComponent: Exiting app.');
          CapacitorApp.exitApp();
        }
      });
    });
  }

  ngAfterViewInit() {
    this.platform.ready().then(() => {

      document.addEventListener('focusin', (event: any) => {
        const target = event.target as HTMLElement;

        // If a date picker is open → blur any focusable element
        if (document.querySelector('snl-date-picker')) {
          const isInput = target.tagName === 'INPUT' || target.tagName === 'TEXTAREA';
          const isContentEditable = target.isContentEditable;
          const hasTabIndex = target.hasAttribute('tabindex');

          if (isInput || isContentEditable || hasTabIndex) {
            event.preventDefault();
            target.blur(); // remove focus → stop keyboard
          }
        }
      });


      // Also handle tabindex dynamically
      const fixTabIndex = () => {
        document
          .querySelectorAll('snl-date-picker-dropdown .container__picker')
          .forEach((el) => {
            const htmlEl = el as HTMLElement;
            if (htmlEl.getAttribute('tabindex') === '0') {
              htmlEl.setAttribute('tabindex', '-1');
            }
          });
      };

      // Run once and keep watching DOM changes
      fixTabIndex();
      const observer = new MutationObserver(fixTabIndex);
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }

  private addNetworkListenerOnce(): void {
    if (this.isNetworkListenerAttached) return;

    Network.addListener('networkStatusChange', async (status) => {
      console.log('AppComponent: networkStatusChange:', {
        connected: status.connected,
        b2cAuthCode: this.authService.b2cAuthCodeBySignalR,
        isLoginInProgress: this.authService.isLoginInProgress
      });

      const token = this._storageService.getDataFromStorage("access_token");

      this.ngZone.run(() => {
        this.authService.isOnlineSubject.next(status.connected);

        if (!status.connected && !this.isNetworkListenerAttached) {
          console.warn('AppComponent: Network disconnected.');
          this.presentNetworkAlert();
        } else if (!token) {
          console.log('AppComponent: Network connected.');

          if (this.authService.b2cAuthCodeBySignalR) {
            console.log('AppComponent: Acquiring B2C access token after reconnect.');
            this.authService.acquireB2CAccessToken(this.authService.b2cAuthCodeBySignalR);
          } else if (!this.authService.isLoginInProgress) {
            console.log('AppComponent: Login not in progress. authGuard would be triggered.');
          }
        }
      });
    });

  }

  async ngOnInit() {
    console.log('AppComponent: ngOnInit() called.');

    this.isSkelton = true;

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Capture event on every URL route change
        if(environment.POSTHOG_ENABLED_TRACKING){ 
          posthog.capture('Route Change', {
            url: event.urlAfterRedirects
          });
        }

        console.log('AppComponent: NavigationEnd - refreshing token.');
        this.refreshAccessToken();
      }
    });

    // Check if offline
    const status = await Network.getStatus();
    this.authService.isOnlineSubject.next(status.connected);
    this.addNetworkListenerOnce();

    if (Capacitor.getPlatform() === 'android') {
      App.addListener('appStateChange', async ({ isActive }) => {
        console.log('AppComponent: App state changed. isActive =', isActive);
          this.authService.setAppActiveState(isActive);

        if (isActive && !this.authService.browserFinished && this.authService.isLoginInProgress) {
          console.log('[App] Became active with login in progress.');

          const token = this._storageService.getDataFromStorage('access_token');
          console.log('AppComponent: Token on app resume:', token);

          if (!token && this.authService.b2cAuthCodeBySignalR) {
            console.log('AppComponent: Acquiring token using SignalR code.');
            this.authService.acquireB2CAccessToken(this.authService.b2cAuthCodeBySignalR);
          } else if (!token && this.authService.lastUrl) {
            console.log('AppComponent: Opening last B2C login URL.');
            Browser.open({ url: this.authService.lastUrl });
          }
        }
      });
    }
  }

  async presentNetworkAlert() {
    console.log('AppConfig: Showing No Internet alert...');
    this.isNetworkListenerAttached = true
    const alert = await this.alertController.create({
      header: 'No Internet',
      message: 'Please check your network connection.',
      backdropDismiss: false,
      buttons: [
        {
          text: 'Retry',
          role: 'reload',
          handler: async () => {
            console.log('Retry clicked. Reloading app...');
            const status = await Network.getStatus();
            if (status.connected) {
              location.reload();
              return true

            }
            else {
              return false
            }
          }
        }
      ]
    });

    await alert.present();
  }

  reloadCurrentComponent() {
    const currentUrl = this.router.url;
    console.log('AppComponent: Reloading current route:', currentUrl);

    this.router.navigateByUrl('/').then(() => {
      this.router.navigateByUrl(currentUrl);
    });
  }


  getDevive() {
    let deviceType = 'web';

    if (this.platform.is('ios') || this.platform.is('iphone')) {
      deviceType = 'ios';
    } else if (this.platform.is('android')) {
      deviceType = 'android';
    }

    console.log('AppComponent: Detected device type:', deviceType);
    return deviceType;
  }

  loadMenuOption(navigationUrl: string) {
    console.log('AppComponent: Loading menu options for route:', navigationUrl);

    this.bottomMenuOptions = [
      {
        iconName: "icon/home",
        iconType: "svg",
        displayName: "Home",
        selected: this.menuselected(navigationUrl, 'home'),
        path: 'home'
      },
      {
        iconName: "icon/files",
        iconType: "svg",
        displayName: "Documents",
        selected: this.menuselected(navigationUrl, 'documents'),
        path: 'documents'
      },
      {
        iconName: "icon/dollar-sign",
        iconType: "svg",
        displayName: "Payroll & expenses",
        selected: this.menuselected(navigationUrl, 'payroll-expenses'),
        path: 'payroll-expenses'
      },
      {
        iconName: "icon/user",
        iconType: "svg",
        displayName: "Profile",
        selected: this.menuselected(navigationUrl, 'profile'),
        path: 'profile'
      }
    ];

    console.log('AppComponent: Menu options loaded:', this.bottomMenuOptions);
  }


  public menuselected(select: string, menu: string) {
    const isSelected = select?.includes(menu);
    console.log(`AppComponent: Menu '${menu}' selected?`, isSelected);
    return isSelected;
  }



  refreshAccessToken() {
    const encRefreshToken: any = this._storageService.getDataFromStorage('refresh_token');
    console.log('AppComponent: Encrypted refresh token:', encRefreshToken);

    if (this.authService.isOnlineSubject.value && encRefreshToken) {
      const { refresh_token } = this.crewSelfService.decryptData(encRefreshToken);
      console.log('AppComponent: Decrypted refresh token:', refresh_token);

      this.authApiService.b2cRefreshTokenApi(refresh_token).subscribe({
        next: (response: any) => {
          console.log('AppComponent: Token refreshed successfully.');

          this._storageService.putDataInStorage(
            'access_token',
            this.crewSelfService.encryptData({ access_token: response.access_token })
          );
          this._storageService.putDataInStorage(
            'refresh_token',
            this.crewSelfService.encryptData({ refresh_token: response.refresh_token })
          );

          this.getApprovedUserDetail();
        },
        error: (err: any) => {
          console.error('AppComponent: Error while refreshing token:', err);
          this.authService.signOut();
        },
      });
    } else {
      console.warn('AppComponent: No internet or refresh token not available.');
    }
  }


  collapsed(data: any) {
    console.log('AppComponent: Collapsed changed:', data);
    this.isCollapsed = data;
  }




  public getApprovedUserDetail() {
    console.log('AppComponent: Fetching approved user details.');

    this.userApiService.fetchUserApprovedDetail(true).subscribe({
      next: (response) => {
        console.log('AppComponent: Received approved user details response:', response);

        if (response.status === 'success') {
          this.isSkelton = false;
          this.loginUserDetail.login_user_name = response.data.FIRST_NAME + ' ' + response.data.LAST_NAME;
          this.loginUserDetail.designation = response.data.RANK_DESCRIPTION;
          this.loginUserDetail.role = response.data.RANK_CODE;
          this.loginUserDetail.profileImage = response.data.PROFILE_IMAGE_URL;

          this.crewSelfService.isFillipinoSet(response.data.POOL_CODE);
          this.crewSelfService.isPoolCodeSet(response.data.POOL_CODE);
          this.crewSelfService.isSetActiveUser(response.data);

          // initialize posthog user session
          if(environment.POSTHOG_ENABLED_TRACKING){
            posthog.identify(response.data.CREW_IPN, {
              name: `${response.data.FIRST_NAME} ${response.data.LAST_NAME}`,
              rank: response.data.RANK_DESCRIPTION,
              environment: environment.NAV_TYPE,
              platform: Capacitor.getPlatform(),
              application: "CSS@Stolt"
            });
          }

        }
      },
      error: (err: any) => {
        console.error('AppComponent: Error fetching user approved detail:', err);
      }
    });
  }


  public getCrewBasicNotifications() {
    console.log('AppComponent: Fetching crew basic notifications.');

    this.userApiService.getCrewBasicNotifications().subscribe({
      next: (response) => {
        console.log('AppComponent: Received crew notification response:', response);

        if (response.data.IS_UPDATED) {
          this.crewSelfService.isBasicNotificationSet(response.data);
        }
      },
      error: (err: any) => {
        console.error('AppComponent: Error fetching default notifications:', err);
      }
    });
  }




  private parseRoute(node: ActivatedRouteSnapshot) {
    const title = node.data['title'];
    console.log('AppComponent: Parsing route. Title:', title);

    this.titleService.setTitle('Crew Self Service 2.0 - ' + title);
    this.pageTitle = title;
    this.sidebar = !!node?.data['sidebar'];

    if (node.firstChild) {
      this.parseRoute(node.firstChild);
    }
  }


  public closeMenu() {
    console.log('AppComponent: Closing menu.');
    this.menu.close();
  }

  ngOnDestroy() {
    console.log('AppComponent: ngOnDestroy called. Cleaning up.');
    this.subscription.unsubscribe();
    Network.removeAllListeners();
  }


  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    console.log('AppComponent: Window resized:', event.target.innerWidth);

    this.crewSelfService.isDesktopSet();
    this.crewSelfService.setCurrentPlatform();
  }


}
